import React from 'react';
import { CheckCircle2Icon, ClockIcon, HeartIcon, LayoutListIcon, ShieldCheckIcon, SparklesIcon } from 'lucide-react';
import { motion } from 'framer-motion';
const outcomes = [{
  icon: ClockIcon,
  title: 'Recuperás horas todas las semanas'
}, {
  icon: LayoutListIcon,
  title: 'Nunca más empezás desde una hoja en blanco'
}, {
  icon: ShieldCheckIcon,
  title: 'Todo organizado en un solo lugar'
}, {
  icon: SparklesIcon,
  title: 'Llegás al aula con más tranquilidad'
}, {
  icon: CheckCircle2Icon,
  title: 'Tenés recursos para prácticamente todo el año'
}, {
  icon: HeartIcon,
  title: 'Más tiempo para vos, fuera de la escuela'
}];
export function OutcomeSection() {
  return <section className="bg-gradient-to-b from-pink-50 to-orange-50 py-10 sm:py-14 md:py-16" data-id="element-83">
      <div className="container mx-auto px-4 md:px-6" data-id="element-84">
        <div className="mx-auto max-w-3xl text-center" data-id="element-85">
          <p className="text-xs font-extrabold uppercase tracking-[0.18em] text-pink-600" data-id="element-86">
            La verdadera transformación
          </p>
          <h2 className="mt-2 text-3xl font-black tracking-tight text-slate-900 sm:text-4xl" data-id="element-87">
            No comprás archivos. Recuperás tranquilidad.
          </h2>
        </div>
        <div className="mx-auto mt-6 grid max-w-5xl gap-2.5 sm:grid-cols-2 sm:gap-3 lg:grid-cols-3" data-id="element-88">
          {outcomes.map(({
          icon: Icon,
          title
        }, index) => <motion.div key={title} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex items-center gap-3 rounded-2xl bg-white p-3.5 shadow-sm ring-1 ring-pink-100" data-id="element-89">
              <span className="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl bg-pink-100 text-pink-600" data-id="element-90">
                <Icon className="h-4.5 w-4.5" data-id="element-91" />
              </span>
              <p className="text-sm font-extrabold leading-snug text-slate-800" data-id="element-92">
                {title}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}